/** Copy for the Membership benefits welcome-pack (editorial layout). */
export const MEMBERSHIP_BENEFITS_CONTENT = {
  brand: 'AXONALL RESERVE',
  subtitle: 'High-level Membership Benefits',
  intro:
    'Reserve membership is designed to give selected advisors a more elevated way to work with Axonall through distinctive access, trusted support, and meaningful participation across the circle.',
  benefits: [
    {
      title: 'Curated Access',
      text: 'Access to a more selective world of stays, experiences, and differentiated travel opportunities shaped around Axonall’s standards.',
    },
    {
      title: 'Axonall Studio',
      text: 'Entry into the private member space through which advisors access product, tools, systems, and account activity.',
    },
    {
      title: 'Journey Artisan Support',
      text: 'A high-touch human layer on bookings, adding care, coordination, and judgement where members require greater attention.',
    },
    {
      title: 'Professional Exchange',
      text: 'Closed-door connection, trusted dialogue, and stronger business conversations among selected advisors within the Reserve circle.',
    },
    {
      title: 'Education & Intelligence',
      text: 'Training, briefings, and insight designed to support sharper client service and more distinctive positioning.',
    },
    {
      title: 'Voice & Influence',
      text: 'A closer role in selected conversations around where high-value travel is heading and how Axonall continues to evolve.',
    },
    {
      title: 'Selected Member Opportunities',
      text: 'Access to private sessions, curated moments, and selected opportunities for deeper participation across the Axonall world.',
    },
    {
      title: 'Black Key Access',
      text: 'The highest level of access within Reserve, extended selectively to a limited number of outstanding members.',
    },
  ],
  closing:
    'Membership is selective and designed to support both distinction in service and a stronger connection to the Axonall world.',
}
